import { Landing } from "components";
import PrivacyView from "./PrivacyView";

export const PrivacyContainer = () => {
  return (
    <Landing>
      <PrivacyView />
    </Landing>
  );
};
